import { useClientConfigProvider } from "@/app/config/client-config-provider";
import HotlineV2 from "@/app/versioning/page/LoginPage/v2/loginComponents/hotlineSupportModalV2";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { IoArrowBackSharp } from "react-icons/io5";
import Image from "next/image";
import CustomButtonV2 from "../CustomButton/CustomButtonV2";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
// import clsx from "clsx"; // Optional: Uncomment if you're using clsx

interface PreLoginCustomHeaderProps {
  showLogo?: boolean;
  onBackClick?: () => void;
  dark?: boolean;
}

const PreLoginCustomHeader = ({
  showLogo = true,
  onBackClick,
  dark,
}: PreLoginCustomHeaderProps) => {
  const [showHotlineModal, setShowHotlineModal] = useState(false);
  const { getImagePath } = useClientConfigProvider();
  const router = useRouter();
  const { config } = useClientConfigProvider();
   const {
      state: { isMobile },
    } = useAppContext();
    console.log('checkmobile', isMobile)

  const handleBack = () => {
    if (typeof onBackClick === "function") {
      onBackClick();
    } else {
      router.back();
    }
  };
  const isShowBackButton = config?.preLoginCustomHeader?.isShowBackButton;

  const showBackButtonSeparately =
    config?.preLoginCustomHeader?.showBackButtonSeparately;
  const isShowHelpButton =
    config?.preLoginCustomHeader?.isShowHelpButton ?? true;

  return (
    <>
      {showHotlineModal ? (
        <HotlineV2
          isOpen={showHotlineModal}
          handleClose={setShowHotlineModal}
        />
      ) : null}

      <div className={`top-bar-v2 ${dark ? "black-only" : ""} display_mobile`}>
        {isShowBackButton && (
          <button className="back-btn-v2" onClick={handleBack}>
            <IoArrowBackSharp size={24} />
          </button>
        )}

        {showLogo && (
          <Image
            src={getImagePath(dark ? "logo.png" : "logo-white.png")}
            alt="Logo"
            className="pre-login-header-logo"
            width={120}
            height={40}
            priority
          />
        )}

        {isShowHelpButton && (
          <CustomButtonV2
            variant="link"
            style={{
              color: dark
                ? "var(--surface-default-primary)"
                : "var(--base-white)",
              fontWeight: 400,
            }}
            className="help-btn-v2"
            onClick={() => setShowHotlineModal(true)}
          >
            Help
          </CustomButtonV2>
        )}
      </div>
      {showBackButtonSeparately && (

        <div className="back_button_prelogin">
          <button className="back-btn-v2" onClick={handleBack}>
            <IoArrowBackSharp size={24} />
          </button>
          {isShowHelpButton && !isMobile &&(
          <CustomButtonV2
            variant="link"
            style={{
              color: dark
                ? "var(--surface-default-primary)"
                : "var(--base-white)",
              fontWeight: 400,
            }}
            className="help-btn-v2"
            onClick={() => setShowHotlineModal(true)}
          >
            Help
          </CustomButtonV2>
        )}
        </div>
      )}
    </>
  );
};

export default PreLoginCustomHeader;
